<template>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <div v-else>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">

                        </th>
                        <th class="text-left">
                            Barcode
                        </th>
                        <th class="text-left">
                            Species
                        </th>
                        <th class="text-left">
                            Weight
                        </th>
                        <th class="text-left">
                            Amount
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in availableSpeciesBatchPools"
                        :key="item.SpeciesBatchPoolID"
                    >
                        <td>
                            <v-checkbox v-model="item.Selected"></v-checkbox>
                        </td>
                        <td>{{ item.Barcode }}</td>
                        <td>{{ item.SpeciesFullName }}</td>
                        <td>{{ item.TotalWeight || 0}}g</td>
                        <td><v-text-field v-model="item.AddedWeight" @input="invalidateInput(item)" :rules="[rules.validateInputWeight(item.AddedWeight,item.TotalWeight)]" suffix="g"></v-text-field></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4" class="text-center">
                            <v-btn
                                color="success"
                                :disabled="!atLeastOneSpeciesBatchPoolSelected||disableSelectedButton"
                                :loading="saving || loading"
                                @click="addSelected"
                            >
                                Add Selected
                            </v-btn>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>
        <div v-if="addSpeciesBatchPoolErrors.length > 0">
            <v-alert text type="error">
                <v-row align="center">
                    <v-col class="grow">
                        <ul>
                            <li
                                v-for="(error, errorIndex) in addSpeciesBatchPoolErrors"
                                :key="errorIndex"
                            >
                                {{error.Barcode ? (error.Barcode + " - ") : ""}}{{error.message}}
                            </li>
                        </ul>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="loadData">Reload Available Species Batch Pools</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>
    </div>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import constants from 'comunet-btg-utah-repository-shared/constants';
import moment from 'moment';

export default {
    components: {
      
    },
    props: {
        speciesID: {
            type: Number,
            default: -1
        },
        venomLotID: {
            type: Number,
            default: -1
        },
        isExternal: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            saving: false,
            disableSelectedButton:false,
            rules:{
                validateInputWeight:(inputWeight,maxWeight)=>inputWeight <= maxWeight || `Input Value can not be greater than ${maxWeight}`
            },
            availableSpeciesBatchPools: [],
            addSpeciesBatchPoolErrors: [],
            addedWeightRules:[]
        }
    },
    computed: {
        atLeastOneSpeciesBatchPoolSelected() {
            return this.selectedSpeciesBatchPools.length > 0;
        },
        selectedSpeciesBatchPools() {
            return this.availableSpeciesBatchPools.filter(mp => mp.Selected);
        }
    },
    methods: {
        invalidateInput(item){
            if(item.Selected&&item.AddedWeight > item.TotalWeight){
                this.$nextTick(()=>{
                    this.disableSelectedButton = true;
                })
            }
            else{
                this.disableSelectedButton = false;
            }

            for(const item of this.availableSpeciesBatchPools){
                if(item.AddedWeight > item.TotalWeight){
                    this.disableSelectedButton = true;
                }
            }
        },
        async loadData() {
            this.loading = true;
            this.addSpeciesBatchPoolErrors = [];
            
            try {
                let data = await venomPoolingAPI.getSpeciesBatchPoolsAvailableForVenomLot(this.venomLotID);
                
                data.sort((a, b) => {
                    return a.Barcode - b.Barcode
                });

                data = data.map(mp => {
                    mp.Selected = false;
                    mp.TotalWeight = mp.TotalWeight - mp.TotalAddedWeight > 0  ? (mp.TotalWeight*10 - mp.TotalAddedWeight*10)/10 : 0 ;
                    return mp;
                });

                this.availableSpeciesBatchPools = data;
            }
            catch (e) {
                this.addSpeciesBatchPoolErrors.push(e);
            }
            finally {
                this.loading = false;
            }
        },
        async addSelected() {
            this.saving = true;
            this.addSpeciesBatchPoolErrors = [];
            const addedSpeciesBatchPools =  this.selectedSpeciesBatchPools.map(sbp => (
                {   
                    AddedWeight: sbp.AddedWeight,
                    SpeciesBatchPoolID:sbp.SpeciesBatchPoolID
                }
            ));

            try {
            for(let item of addedSpeciesBatchPools){
                await venomPoolingAPI.addSpeciesBatchPoolsToVenomLot(
                    item.SpeciesBatchPoolID,
                    item.AddedWeight,
                    this.venomLotID,
                    this.speciesID
                );
            }
                this.loadData();
                this.$emit("recordsAdded");
            }
            catch (e) {
                this.addSpeciesBatchPoolErrors.push(e);
            }
            finally {
                this.saving = false;
                let emptySpeciesBatchPools = [];
                for(const item of this.availableSpeciesBatchPools ){
                    if(parseInt(item.AddedWeight) == item.TotalWeight){
                        emptySpeciesBatchPools.push(item);
                    }
                }
                if(emptySpeciesBatchPools.length > 0){
                    const emptySpeciesBatchPoolIDs = [];
                    for(const item of emptySpeciesBatchPools ){
                        emptySpeciesBatchPoolIDs.push(item.SpeciesBatchPoolID);
                    }
                    this.$emit("showCloseDialog", emptySpeciesBatchPoolIDs);
                }
            }
        }
    },
    async created() {
        await this.loadData();
    }
}
</script>